import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'

/** Only from the real `require_paid_business`/`require_paid_plan` gates, never invented. */
const FREE_ITEMS = ['autoevaluacion', 'resumen'] as const

const PRO_ITEMS = [
  'empleados',
  'matriz',
  'evidencias',
  'matrizLegal',
  'plan',
  'acciones',
  'designaciones',
  'incidentes',
  'incapacidades',
  'certificacion',
  'bateria',
] as const

function CheckItem({label, tone}: {label: string; tone: 'muted' | 'primary'}) {
  return (
    <li className="flex gap-2 text-sm">
      <span aria-hidden className={tone === 'primary' ? 'text-primary' : 'text-muted-foreground'}>
        ✓
      </span>
      <span className={tone === 'primary' ? 'text-foreground' : 'text-muted-foreground'}>{label}</span>
    </li>
  )
}

export function FreeProColumns() {
  const {t} = useTranslation()
  return (
    // Alturas igualadas a propósito: que la columna Free quede corta al lado de la Pro es la comparación.
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="surface space-y-2 p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-heading text-sm text-foreground">{t('planFacturacion.value.freeTitle')}</h3>
          <Tag tone="neutral">{t('planFacturacion.value.freeHint')}</Tag>
        </div>
        <ul className="space-y-1.5">
          {FREE_ITEMS.map((key) => (
            <CheckItem key={key} tone="muted" label={t(`planFacturacion.value.free.${key}`)} />
          ))}
        </ul>
      </div>
      <div className="surface space-y-2 border-primary/30 bg-accent/40 p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-heading text-sm text-foreground">{t('planFacturacion.value.proTitle')}</h3>
          <Tag tone="neutral">{t('planFacturacion.value.proHint')}</Tag>
        </div>
        <ul className="space-y-1.5">
          {PRO_ITEMS.map((key) => (
            <CheckItem key={key} tone="primary" label={t(`planFacturacion.value.pro.${key}`)} />
          ))}
        </ul>
      </div>
    </div>
  )
}
